<style scoped>
.shadowfilter {
  /* background-repeat: no-repeat;
    filter: drop-shadow(0px 0px 10px blue); */
}
</style>
<script>
import { authComputed } from '@state/helpers'
import ProfileModal from '@views/account/user/profile-modal'
import SockJS from 'sockjs-client'
import Stomp from 'webstomp-client'

export default {
  components: { ProfileModal },
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      profile: '',
      openProfile: false,
      logolg: {
        display: 'block',
        'background-color': 'white',
      },
      received_messages: [],
      send_message: null,
      connected: false,
    }
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    // this.connect()
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu()
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar()
    },
    connect() {
      this.socket = new SockJS('http://localhost:8080/msg')
      this.stompClient = Stomp.over(this.socket)
      this.stompClient.connect(
        {},
        (frame) => {
          this.connected = true
          console.log(frame)
          this.stompClient.subscribe('/topic/messages', (tick) => {
            console.log(tick)
            this.received_messages.push(JSON.parse(tick.body).content)
          })
        },
        (error) => {
          console.log(error)
          this.connected = false
        }
      )
    },
    disconnect() {
      if (this.stompClient) {
        this.stompClient.disconnect()
      }
      this.connected = false
    },
    tickleConnection() {
      this.connected ? this.disconnect() : this.connect()
    },
  },
}
</script>

<template>
  <!-- Topbar Start -->
  <div
    class="navbar-custom"
    style="
      background-color: rgba(255, 255, 255, 0.3);
      backdrop-filter: blur(5px);
    "
  >
    <ul class="d-flex list-unstyled topnav-menu float-right mb-0">
      <li v-if="false" class="d-none d-sm-block">
        <form class="app-search">
          <div class="app-search-box">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Search..." />
              <div class="input-group-append">
                <button class="btn" type="submit">
                  <i class="mdi mdi-search"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </li>

      <b-nav-item-dropdown
        right
        class="notification-list"
        menu-class="profile-dropdown"
      >
        <template slot="button-content">
          <div v-waves class="nav-user mr-0">
            <img
              :src="currentUser ? currentUser.avatar : ''"
              alt="user-image"
              class="rounded-circle"
            />
            <span style="margin-top: -5px">
              <span class="pro-user-name ml-1">
                {{ currentUser ? currentUser.fullName : '' }}
                <i class="mdi mdi-chevron-down"></i>
              </span>
            </span>
          </div>
        </template>

        <b-dropdown-item to="/profile">
          <i class="mdi mdi-settings-outline mr-1"></i>
          <span>Profile</span>
        </b-dropdown-item>

        <b-dropdown-item
          href="#"
          @click="
            profile = 'password'
            openProfile = true
          "
        >
          <i class="mdi mdi-lock-outline mr-1"></i>
          <span>Change Password</span>
        </b-dropdown-item>

        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item href="/logout">
          <i class="mdi mdi-logout mr-1"></i>
          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
      <b-nav-item
        v-b-tooltip.hover
        title="Help"
        to="/help"
        target="_blank"
        exact
        exact-active-class="active"
      >
        <template slot="button-content" class="nav-link dropdown-toggle">
          <div v-waves class="button-content" style="font-size: 1.5em"
            ><i class="mdi mdi-help-circle-outline"></i>
            <!-- <span class="badge badge-danger rounded-circle noti-icon-badge">0</span> -->
          </div>
        </template>
      </b-nav-item>
      <!-- <b-nav-item-dropdown right class="notification-list">
        <template slot="button-content" class="nav-link dropdown-toggle">
          <div v-waves class="button-content"
            ><i class="mdi mdi-bell-outline noti-icon"></i>
            <span class="badge rounded-circle noti-icon-badge">0</span>
          </div>
        </template>

        <b-dropdown-text href="#" class="dropdown-item noti-title">
          <h5 class="m-0">
            <span class="float-right">
              <a href class="text-dark">
                <small>Clear All</small>
              </a> </span
            >Notification
          </h5>
        </b-dropdown-text>

        <b-dropdown-text href="#" class="p-0">
          <VuePerfectScrollbar v-once class="noti-scroll">
            <a
              href="javascript:void(0);"
              class="dropdown-item notify-item active"
            >
              <div class="notify-icon">
                <img
                  src="@assets/images/users/user-1.jpg"
                  class="img-fluid rounded-circle"
                  alt
                />
              </div>
              <p class="notify-details">Cristina Pride</p>
              <p class="text-muted mb-0 user-msg">
                <small>Hi, How are you? What about our next meeting</small>
              </p>
            </a>

            <a href="javascript:void(0);" class="dropdown-item notify-item">
              <div class="notify-icon bg-primary">
                <i class="mdi mdi-comment-account-outline"></i>
              </div>
              <p class="notify-details">
                Caleb Flakelar commented on Admin
                <small class="text-muted">1 min ago</small>
              </p>
            </a>
            <a href="javascript:void(0);" class="dropdown-item notify-item">
              <div class="notify-icon">
                <img
                  src="@assets/images/users/user-4.jpg"
                  class="img-fluid rounded-circle"
                  alt
                />
              </div>
              <p class="notify-details">Karen Robinson</p>
              <p class="text-muted mb-0 user-msg">
                <small>Wow ! this admin looks good and awesome design</small>
              </p>
            </a>
            <a href="javascript:void(0);" class="dropdown-item notify-item">
              <div class="notify-icon bg-warning">
                <i class="mdi mdi-account-plus"></i>
              </div>
              <p class="notify-details">
                New user registered.
                <small class="text-muted">5 hours ago</small>
              </p>
            </a>

            <a href="javascript:void(0);" class="dropdown-item notify-item">
              <div class="notify-icon bg-info">
                <i class="mdi mdi-comment-account-outline"></i>
              </div>
              <p class="notify-details">
                Caleb Flakelar commented on Admin
                <small class="text-muted">4 days ago</small>
              </p>
            </a>

            
            <a href="javascript:void(0);" class="dropdown-item notify-item">
              
              <p class="notify-details">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <b
                  >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b
                >
                <small class="text-muted">&nbsp;</small>
              </p>
            </a>
          </VuePerfectScrollbar>

          <a
            href="javascript:void(0);"
            class="dropdown-item text-center text-primary notify-item notify-all"
          >
            View all
            <i class="fi-arrow-right"></i>
          </a>
        </b-dropdown-text>
      </b-nav-item-dropdown> -->
    </ul>

    <!-- LOGO -->
    <div class="logo-box">
      <a href="index.html" class="logo text-center">
        <span
          class="logo-lg shadowfilter"
          :style="{ 'background-color': currentUser.bgColor }"
        >
          <!-- <img src="@assets/images/logo-light.png" alt height="18" /> this.currentClientDetail -->
          <img :src="currentUser ? currentUser.logo : ''" alt height="40" />
          <!-- <span class="logo-lg-text-light">Xeria</span> -->
        </span>
        <span class="logo-sm">
          <!-- <span class="logo-sm-text-dark">X</span> -->
          <img src="@assets/images/logo-sm.png" alt height="35" />
        </span>
      </a>
    </div>

    <ul class="list-unstyled topnav-menu topnav-menu-left m-0">
      <li>
        <button v-waves class="button-menu-mobile" @click="toggleMenu">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </li>
      <li style="padding-top: 18px; font-size: x-large"
        ><b>{{ currentUser ? currentUser.orgName : '' }}</b></li
      >
      <b-nav-item-dropdown v-if="false" class="d-none d-lg-block">
        <template slot="button-content">
          <div v-waves class="button-content">
            Create New
            <i class="mdi mdi-chevron-down"></i>
          </div>
        </template>
        <b-dropdown-item href="#">
          <i class="mdi mdi-briefcase-outline mr-1"></i>
          <span>New Projects</span>
        </b-dropdown-item>
        <b-dropdown-item href="#">
          <i class="mdi mdi-account-outline mr-1"></i>
          <span>Create Users</span>
        </b-dropdown-item>
        <b-dropdown-item href="#">
          <i class="mdi mdi-chart-bar mr-1"></i>
          <span>Revenue Report</span>
        </b-dropdown-item>
        <b-dropdown-item href="#">
          <i class="mdi mdi-settings mr-1"></i>
          <span>Settings</span>
        </b-dropdown-item>
        <b-dropdown-item href="#">
          <i class="mdi mdi-headphones mr-1"></i>
          <span>Help & Support</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </ul>
    <ProfileModal
      :profile="profile"
      :open="openProfile"
      @modal-close="openProfile = false"
      @modal-open="openProfile = true"
    />
  </div>
  <!-- end Topbar -->
</template>

<style lang="scss">
.noti-scroll {
  height: 220px;
}
.ps > .ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
  width: 6px !important;
}
.button-menu-mobile {
  outline: none !important;
  span {
    width: 18px;
    height: 2px;
    background-color: #414d5f;
    display: block;
    margin: 5px 12px;
  }
  span:nth-of-type(2) {
    width: 24px;
  }
}
</style>
